import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

type PhoneInputState = 'default' | 'hover' | 'focus';

@Injectable()
export class PhoneCountryCodeService {
  private _isHovered = new BehaviorSubject<boolean>(false);
  public isHovered$ = this._isHovered as Observable<boolean>;
  public setIsHovered = (isHovered: boolean) => this._isHovered.next(isHovered);

  private _isFocused = new BehaviorSubject<boolean>(false);
  public isFocused$ = this._isFocused as Observable<boolean>;
  public setIsFocused = (isFocused: boolean) => this._isFocused.next(isFocused);

  public interactionState$: Observable<PhoneInputState> = combineLatest([this.isHovered$, this.isFocused$]).pipe(
    map(([isHovered, isFocused]) => {
      if (isFocused) return 'focus';
      if (isHovered) return 'hover';
      return 'default';
    })
  );
}
